import { render, staticRenderFns } from "./ModuleSubs.vue?vue&type=template&id=25b91441&"
import script from "./ModuleSubs.vue?vue&type=script&lang=js&"
export * from "./ModuleSubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports